<template>
  <b-button
    pill
    :disabled="!s3Key || loading"
    :variant="loadFailed ? 'danger' : 'light'"
    class="btn-sm download-file-button"
    @click="onButtonClick"
  >
    <b-spinner v-if="loading" small class="align-middle" />
    <b-icon v-else icon="cloud-download-fill" class="download-icon" />
    <span v-if="title">{{ title }}</span>
  </b-button>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'S3FileDownloadButton',

  props: {
    s3Key: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loadFailed: false,
      loading: false,
    };
  },

  methods: {
    ...mapActions(['fetchS3DownloadLink']),

    async onButtonClick() {
      if (!this.s3Key) {
        return null;
      }

      this.loading = true;
      this.loadFailed = false;

      try {
        const link = await this.fetchS3DownloadLink({ s3Key: this.s3Key });
        window.open(link, '_blank');
      } catch (error) {
        this.loadFailed = true;
        console.error(`Failed to get download link for "${this.s3key}"`, error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.download-file-button {
  background-color: #e2e4e5;
  box-shadow: 0px 3px 6px 0px #97979752;
  border-color: #e2e4e5;
}

.download-file-button.btn-danger {
  background-color: #f0504a;
  border-color: #f0504a;
}

.download-icon {
  font-size: 100% !important;
  vertical-align: text-top !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/S3FileDownloadButton.vue